import React from "react";
import { Box } from "@chakra-ui/react";

export const NavbarShadow: React.FC = () => (
	<Box h={"8px"} boxShadow="md"/>
);
